<template>
    <section>
        <List :title="table.title" :breadcumb="table.breadcumb" :dataTable="table.dataTable">
            <template v-slot:search>
                <div class="input-group form-search-rounded">
                    <input class="form-control py-2 border-right-0 border" v-model.lazy="search" type="search"
                        id="example-search-input" placeholder="Cari bidang disini..">
                    <span class="input-group-append">
                        <div class="input-group-text bg-transparent">
                            <a href="#" class="text-blue"><i class="fa fa-search"></i></a>
                        </div>
                    </span>
                </div>
            </template>

            <template #top-list>
                <div class="row mb-2">
                    <div class="col-12">
                        <ul class="nav custom-nav-box">
                            <li v-for="type in ['all', 'pusat', 'unit']" :key="type" class="nav-item">
                                <a @click="$router.replace({ path: $route.path, query: { type } })" :class="{
                                    'nav-link': true,
                                    'active': ($route.query?.type || 'all') === type,
                                    'text-capitalize': true
                                }">
                                    {{ type }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>

            <template v-slot:columnHeader>
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Nama Kontrak</th>
                        <th>Nama Amandemen</th>
                        <th>Type Amandemen</th>
                        <th>Durasi Berjalan</th>
                        <th>Uraian Proses</th>
                        <th>Status</th>
                        <th width="10%">Aksi</th>
                    </tr>
                </thead>
            </template>

            <template v-slot:action="{ data }">
                <div class="btn-action-block">
                    <button type="button" @click="$router.push(`/kontrak/${data?.id}`)"
                        class="btn btn-icon-small btn-success-trans waves-effect waves-light">
                        <i class="fa fa-eye"></i>
                    </button>
                </div>
            </template>

            <template #cell(judul_kontrak)="{ judul_kontrak, id }">
                <router-link style="font-size: 15px" :to="`/kontrak/${id}`" v-text="judul_kontrak"></router-link>
            </template>
            <template #cell(type)="{ type }">
                <span class="text-capitalize">{{ type == 1 ? 'Unit' : 'Pusat' }}</span>
            </template>
            <template #cell(duration)="{ duration }">
                <span>{{ duration }} Hari</span>
            </template>
            <template #cell(uraian_proses)="{ uraian_proses }">
                <span class="text-capitalize">{{ uraian_proses }}</span>
            </template>
            <template #cell(status)="{ status }">
                <span class="text-capitalize">{{ getStatusText(status) }}</span>
            </template>
        </List>
    </section>
</template>

<script>
import List from '@/components/List.vue'
export default {
    components: {
        List,
    },
    data() {
        return {
            table: {
                title: "Proses Amandemen Kontrak",
                dataTable: {
                    lists: [],
                    columns: ['judul_kontrak', 'name', 'type', 'duration', 'uraian_proses', 'status']
                }
            },
            search: null,
            amendmentStatus: []
        }
    },
    async mounted() {
        let _ = this
        await _.getAmendmentStatus()
        await _.getList()
        _.$root.$on("paginate", async (data) => {
            await _.getList(data)
        });
    },
    beforeDestroy() {
        this.$root.$off("paginate");
    },
    methods: {
        getList(page = 1) {
            const typeMap = {
                all: '',
                pusat: '0',
                unit: '1',
            };

            const typeKey = this.$route.query?.type || 'all';
            const type = typeMap[typeKey] || typeMap.all;

            const params = new URLSearchParams({
                key: this.search || '',
                page: page.toString(),
                per_page: '10',
                type
            });

            this.table.dataTable.lists = []
            this.axios
                .get(`/v3/dashboard/kontrak-amandemen-all?${params.toString()}`)
                .then((resp) => {
                    this.table.dataTable.lists = resp.data.data;
                })
                .catch((err) => {
                    console.error(err.response);
                });
        },
        getAmendmentStatus() {
            let _ = this;
            return _.axios
                .get(`/v3/misc/amandemen-status`)
                .then((resp) => {
                    _.amendmentStatus = resp.data.data;
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        getStatusText(statusNumber) {
            const status = this.amendmentStatus?.find(s => s.level == statusNumber);
            return status?.name || 'blm';
        }
    },
    computed: {
        watcher() {
            return this.search || this.$route.query
        }
    },
    watch: {
        watcher: function () {
            this.getList()
        },
    }
}
</script>